import { Toast } from '@whelk/components';
import { isNative, isOverseas } from '@whelk/const/src/env';
import { LocalStorageShowLoginModal } from '@whelk/const/src/token';
import { LOGIN_TYPE, postLoginByPhoneCode, postLogout } from '@whelk/services/src/user';
import { store } from '@whelk/store';
import { setClearHistoryStore } from '@whelk/store/slices/historyListSlice';
import { setContactPageOpen } from '@whelk/store/slices/layoutSlice';
import { login, logout } from '@whelk/store/slices/userSlice';
import { signOut } from 'firebase/auth';
import { auth } from './firebase';
import { nativeBridge } from '@whelk/utils/src/bridge/callNativeBridge';

import { removeStorageUnionID, removeStorageToken } from './checkToken';
import { openLoginModal } from './login';

export const onClearUserInfo = async () => {
  removeStorageToken();
  removeStorageUnionID();
  // TODO: 退出登录时的清理逻辑
  store.dispatch(logout());
};

export const callNativeLoginOut = () => {
  onClearUserInfo();
};
interface LogoutCallbackParams {
  showLoginModal?: boolean;
  delay?: number;
  toastText?: string;
  skipPage?: boolean;
}

export const logoutCallback = async (params?: LogoutCallbackParams) => {
  const { toastText = '', delay = 0, showLoginModal = true, skipPage = true } = params ?? {};

  removeStorageToken();
  removeStorageUnionID();

  if (toastText) {
    Toast.show(toastText);
  }

  if (delay) {
    await new Promise((resolve) => setTimeout(resolve, delay));
  }

  // 退出登录时的清理逻辑
  store.dispatch(logout());
  store.dispatch(setContactPageOpen(false));
  // 清除对话历史
  store.dispatch(setClearHistoryStore());
  signOut(auth);

  if (isNative) {
    Toast.show('退出登录');
    nativeBridge.callNative({ methodName: 'onTokenExpired' });
    return;
  }

  // showLoginModal 默认 true，主动退出登录时为 false
  if (location.pathname !== '/' || location.search) {
    // 如果不在首页，返回首页
    // 如果在聊天页，返回首页会刷新页面，记录一个标志在 localStorage
    if (skipPage) location.href = '/';
    if (showLoginModal) {
      localStorage.setItem(LocalStorageShowLoginModal, '1');
    }
  } else {
    // 不在聊天页，打开登录弹窗
    if (showLoginModal) {
      openLoginModal();
    }
  }

  if (!isOverseas) {
    // 告知服务器，恢复匿名登陆
    const res = await postLoginByPhoneCode({
      loginType: LOGIN_TYPE.LOGINTYPEANONYMOUS,
    });
    if (!res) return;
    store.dispatch(login(res));
  }
};

// 用户主动退登，如果是后端接口报错401，不需要调用这个方法，只需要调上面 logoutCallback
export const onPostLogout = (params?: LogoutCallbackParams) => {
  if (isNative) {
    Toast.show('退出登录');
    nativeBridge.callNative({ methodName: 'logout', params: { loginFrom: 'chat_page' } });
    return;
  }
  postLogout().finally(() => {
    logoutCallback(params);
  });
};
